module.exports = __webpack_public_path__ + "assets/images/H-grey-icon.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/H-grey-icon.png
// module id = 389
// module chunks = 1